export const leaseConstants = {
  LEASE_LIST_REQUEST: "LEASE_LIST_REQUEST",
  LEASE_LIST_COMPLETE: "LEASE_LIST_COMPLETE",
  LEASE_LIST_ERROR: "LEASE_LIST_ERROR",

  LEASE_SUMMERY: "LEASE_SUMMERY",

  CURRENCY: "CURRENCY",
  NUMBER_OF_ACCOUNTS: "NUMBER_OF_ACCOUNTS",
  TOTAL_LEASE_PAYABLE_AMOUNT: "TOTAL_LEASE_PAYABLE_AMOUNT",
};
